// extracted by mini-css-extract-plugin
module.exports = {"onboardWrapper":"Onboard_onboardWrapper__3a9Po","onboard":"Onboard_onboard__2DC-S"};